import { NodeSelection } from "prosemirror-state";
import { dateToAttrValue } from "./helpers";
export function insertDateCommand() {
    return (match, view) => {
        const node = view.state.schema.nodes.date_pill.create({
            date: dateToAttrValue(new Date()),
        });
        const tr = view.state.tr;
        const { from, to } = match.range;
        tr.replaceRangeWith(from, to, node);
        tr.setSelection(new NodeSelection(tr.doc.resolve(from)));
        view.dispatch(tr);
    };
}
